module.exports = __webpack_public_path__ + "img/students.b647aed6.svg";